const regex = new RegExp('^(http|https)://', 'i')

export const normalizeUrl = (url: string) => {
  if (regex.test(url)) {
    return url
  }

  return `https://${url}`
}
